import 'react-datepicker/dist/react-datepicker.css'
import React, { useEffect, useRef, useState } from 'react'
import Moment from 'moment'
import InputKeyValue from '../shared/InputKeyValue'
import { Search } from '../normalizer'
import { prefix } from '../../../i18n'

const tInvoice = prefix('invoice')

const DEBOUNCE_MS = 400

const toPayload = ({
  number,
  username,
  storeName,
  initialInvoiceDate,
  endInvoiceDate,
  initialRegistryDate,
  endRegistryDate,
}) => ({
  number,
  username,
  storeName,
  initialInvoiceDate: initialInvoiceDate ? Moment(initialInvoiceDate).toString() : undefined,
  endInvoiceDate:     endInvoiceDate     ? Moment(endInvoiceDate).toString()     : undefined,
  initialRegistryDate: initialRegistryDate ? Moment(initialRegistryDate).toString() : undefined,
  endRegistryDate:     endRegistryDate     ? Moment(endRegistryDate).toString()     : undefined,
})

const InvoiceSearch = ({ onSearchRequest }) => {
  const [filters, setFilters] = useState({
    number: '',
    username: '',
    storeName: '',
    initialInvoiceDate: null,
    endInvoiceDate: null,
    initialRegistryDate: null,
    endRegistryDate: null,
  })

  const timerRef = useRef(null)
  const firstRun = useRef(true)

  useEffect(() => {
    if (firstRun.current) {
      firstRun.current = false
      return
    }
    if (timerRef.current) clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => {
      if (onSearchRequest) onSearchRequest(toPayload(filters))
    }, DEBOUNCE_MS)
    return () => timerRef.current && clearTimeout(timerRef.current)
  }, [filters, onSearchRequest])

  const update = (key) => (eventOrValue) => {
    const value = eventOrValue && eventOrValue.target
      ? eventOrValue.target.value
      : eventOrValue
    setFilters(prev => ({ ...prev, [key]: value }))
  }

  return (
    <div className="invoice-layout-filters">
      <div className="invoice-layout-filters-search">
        <InputKeyValue
          title={tInvoice('search-label')}
          leftIcon={<Search />}
          type="text"
          name="number"
          placeholder={tInvoice('search-label')}
          value={filters.number}
          onChange={update('number')}
        />
      </div>

      <div className="invoice-layout-filters-date">
        <InputKeyValue
          title={tInvoice('invoice-date-start')}
          type="date"
          name="initialInvoiceDate"
          value={filters.initialInvoiceDate}
          onChange={update('initialInvoiceDate')}
        />
      </div>
      <div className="invoice-layout-filters-date">
        <InputKeyValue
          title={tInvoice('invoice-date-end')}
          type="date"
          name="endInvoiceDate"
          value={filters.endInvoiceDate}
          onChange={update('endInvoiceDate')}
        />
      </div>

      <div className="invoice-layout-filters-date">
        <InputKeyValue
          title={tInvoice('registry-date-start')}
          type="date"
          name="initialRegistryDate"
          value={filters.initialRegistryDate}
          onChange={update('initialRegistryDate')}
        />
      </div>
      <div className="invoice-layout-filters-date">
        <InputKeyValue
          title={tInvoice('registry-date-end')}
          type="date"
          name="endRegistryDate"
          value={filters.endRegistryDate}
          onChange={update('endRegistryDate')}
        />
      </div>
    </div>
  )
}

export default InvoiceSearch
